export default function FinalCTA() {
  return (
    <>
      <section className="py-24 px-6 relative">
        <div className="absolute inset-0 bg-gradient-to-br from-violet-600/20 via-transparent to-blue-600/20"></div>
        
        <div className="max-w-4xl mx-auto relative z-10 text-center">
          <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/20 rounded-3xl p-12 md:p-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Déployez votre Assistant Exécutif IA
              <br />
              <span className="bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
                dès maintenant
              </span>
            </h2>
            
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Rejoignez les dirigeants qui ont choisi l'efficacité et la performance.
            </p>

            <a 
              href="https://calendly.com/contact-assistantexecutifai/30min?back=1&month=2026-01" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block px-10 py-5 bg-gradient-to-r from-violet-600 to-blue-600 rounded-lg text-lg font-semibold hover:shadow-2xl hover:shadow-violet-500/50 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer mb-6"
            >
              Réserver une consultation gratuite
            </a>

            <p className="text-sm text-gray-400">
              <strong className="text-white">Sans engagement.</strong> Résultats concrets.
            </p>

            <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-sm text-gray-400">
              <div className="flex items-center space-x-2">
                <i className="ri-check-line text-violet-400"></i>
                <span className="whitespace-nowrap">Démo personnalisée</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-check-line text-violet-400"></i>
                <span className="whitespace-nowrap">Analyse de vos besoins</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-check-line text-violet-400"></i>
                <span className="whitespace-nowrap">Proposition sur-mesure</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-gradient-to-b from-transparent to-[#05050a] py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img 
                  src="https://static.readdy.ai/image/ac6eabdb4cc8c584e68459ed2e8db63e/511f79aa6cb452487d1b4ad399421a46.png" 
                  alt="AI Exécutif Assistant" 
                  className="w-10 h-10 object-contain"
                />
                <span className="text-sm font-semibold bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent whitespace-nowrap">AI EXÉCUTIF ASSISTANT</span>
              </div>
              <p className="text-sm text-gray-400">
                Votre bras droit stratégique, disponible 24/7.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4 whitespace-nowrap">Solution</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="#fonctionnalites" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Fonctionnalités</a></li>
                <li><a href="#benefices" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Bénéfices</a></li>
                <li><a href="#cas-usage" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Cas d'usage</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4 whitespace-nowrap">Entreprise</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">À propos</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Contact</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Blog</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4 whitespace-nowrap">Légal</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="/mentions-legales" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Mentions légales</a></li>
                <li><a href="/confidentialite" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Confidentialité</a></li>
                <li><a href="/cgv" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">CGV</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between text-sm text-gray-400">
            <p>© 2026 AI Exécutif Assistant. Tous droits réservés.</p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}